import React from 'react';

import {Stepper, StepperItem} from '@pb/kit-component-stepper';

import {CREATE_USER_STEPS, STEP_TITLE} from '../../constants';

import {createUserProgressBar} from './progress-bar.module.styl';

type Props = {
    selectedStep: CREATE_USER_STEPS,
    canSetupAdminRole: boolean,
    canViewLimits: boolean,
    onChangeStep?: (step: CREATE_USER_STEPS) => void,
};

const STEPS = [{
    caption: STEP_TITLE[CREATE_USER_STEPS.USER_DETAILS],
    step: CREATE_USER_STEPS.USER_DETAILS,
}, {
    caption: STEP_TITLE[CREATE_USER_STEPS.SETTINGS],
    step: CREATE_USER_STEPS.SETTINGS,
}, {
    caption: STEP_TITLE[CREATE_USER_STEPS.LIMITS],
    step: CREATE_USER_STEPS.LIMITS,
}, {
    caption: STEP_TITLE[CREATE_USER_STEPS.ROLE_SETTINGS],
    step: CREATE_USER_STEPS.ROLE_SETTINGS,
},
];

export const CreateUserProgressBar = ({
    selectedStep,
    canSetupAdminRole,
    onChangeStep,
    canViewLimits,
}: Props) => {
    const visibleSteps = STEPS
        .filter(s => s.step !== CREATE_USER_STEPS.LIMITS || canViewLimits)
        .filter(s => s.step !== CREATE_USER_STEPS.ROLE_SETTINGS || canSetupAdminRole);

    const selectedIndex = visibleSteps.findIndex(step => step.step === selectedStep);
    const activeStep = selectedIndex !== -1 ? selectedIndex : Math.max(0, visibleSteps.length - 1);

    return (
        <Stepper className={createUserProgressBar} activeStep={activeStep}>
            {visibleSteps.map((step, index) => (
                <StepperItem
                    key={`${step.step}`}
                    caption={step.caption}
                    onClick={() => {
                        if (onChangeStep) {
                            onChangeStep(step.step);
                        }
                    }}
                    disabled={selectedStep < step.step}
                    active={selectedStep === step.step}
                    completed={selectedStep > step.step}
                    isFirst={index === 0}
                />
            ))}
        </Stepper>
    );
};
